/**
 * 큐 로그 (/adm/queue-logs) — 4채널 통합 큐(queue·firebase·alimtalk·bizgo) 적재·처리 기록과 payload 상세
 * ($j.Pages.Admin.QueueLog / body data-page-name="QueueLog")
 */
export default class QueueLog {
    initialize() { initialize(); }
}

let $table = null;

function initialize() {
    $('#btnReload').on('click', reloadTable);
    $('#btnResetFilter').on('click', resetFilter);
    // payload → 상세 모달
    $('#log-table').on('click', 'a.cell-detail[data-n]', function (e) {
        e.preventDefault();
        showDetail(Number(this.dataset.n));
    });

    $('#f_date_from, #f_date_to').mobiscroll().datepicker({
        controls: ['calendar'],
        dateFormat: 'YYYY-MM-DD',
        locale: mobiscroll.localeKo,
        buttons: [],
    });
    loadTable();
}

function loadTable() {
    const columns = [
        {data: 'num', title: '#', width: '70px'},
        {data: 'channel', title: '채널', width: '90px',
            render: v => channelTag(v)},
        {data: null, title: 'rel', width: '180px',
            render: r => {
                const empty = !r.rel_table && !r.rel_action && (!r.rel_id || r.rel_id === '0');
                if (empty) return '';
                const parts = [];
                if (r.rel_table || r.rel_action) {
                    parts.push(`${r.rel_table || ''}<span class="ql-dot">.</span>${r.rel_action || ''}`);
                }
                if (r.rel_id && r.rel_id !== '0') {
                    parts.push(`<span class="ql-blue">#${r.rel_id}</span>`);
                }
                return `<small>${parts.join(' ')}</small>`;
            }},
        {data: null, title: '상태', width: '70px',
            render: r => statusBadge(r)},
        {data: 'reg_time', title: '예약', width: '160px',
            render: v => v ? renderDt(v) : '-'},
        {data: 'start_time', title: '시작', width: '160px',
            render: v => v ? renderDt(v) : '<span class="text-muted">-</span>'},
        {data: 'end_time', title: '완료', width: '160px',
            render: v => v ? renderDt(v) : '<span class="text-muted">-</span>'},
        {data: 'payload_preview', title: 'payload',
            render: (v, _, row) => v
                ? `<a href="#" class="cell-detail" data-n="${row.num}">${escapeHtml(v.substr(0, 30))}${v.length > 30 ? '…' : ''}</a>`
                : '<a href="#" class="cell-detail" data-n="' + row.num + '">-</a>'}
    ];

    if ($table) { $table.destroy(); $('#log-table').empty(); }

    $table = new DataTable('#log-table', {
        autoWidth: false,
        columns,
        headerCallback: thead => $(thead).find('th').css('text-align', 'center'),
        ajax: {
            url: '/adm/ajax/queue-logs/list',
            type: 'post',
            data: d => Object.assign(d, {
                channel:    $('#f_channel').val(),
                status:     $('#f_status').val(),
                rel_table:  $('#f_rel_table').val(),
                rel_action: $('#f_rel_action').val(),
                rel_id:     $('#f_rel_id').val(),
                date_from:  $('#f_date_from').val(),
                date_to:    $('#f_date_to').val(),
            })
        },
        language: {
            emptyTable: '데이터가 없습니다.',
            info: '_TOTAL_ 건',
            loadingRecords: '로딩 중...',
            zeroRecords: '일치하는 결과가 없습니다.',
            paginate: {previous: "<i class='fa fa-chevron-left'></i>", next: "<i class='fa fa-chevron-right'></i>"}
        },
        processing: true,
        serverSide: true,
        ordering: false,
        pageLength: 25,
        lengthChange: false,
        searching: false
    });
}

function reloadTable() {
    $table && $table.ajax.reload();
}

function resetFilter() {
    $('#f_channel,#f_status,#f_rel_table,#f_rel_action,#f_rel_id').val('');
    // 기본 기간 = 서버가 그려 둔 value 속성(7일 전 ~ 오늘)
    $('#f_date_from').val($('#f_date_from').prop('defaultValue'));
    $('#f_date_to').val($('#f_date_to').prop('defaultValue'));
    reloadTable();
}

function showDetail(num) {
    $.post('/adm/ajax/queue-logs/detail', {num}, function (res) {
        if (!res.result) { alert('조회 실패'); return; }
        const r = res.row;
        const payload = r.payload ? JSON.stringify(JSON.parse(r.payload), null, 2) : '';

        // firebase 채널 — 실제 전송본(buildFields 출력) 미리보기
        let sentHtml = '';
        if (res.sent_preview) {
            const sp = res.sent_preview;
            const sentJson = JSON.stringify(sp.fields, null, 2);
            sentHtml = `
                <h6 class="mt-3">실제 전송본 미리보기
                    <small class="text-muted">— buildFields 출력(데몬 전송 직전) · app=<b>${escapeHtml(sp.app)}</b> · 수신 ${sp.mem_cnt}명</small>
                </h6>
                <p class="text-muted mb-1 ql-fs11">
                    큐 payload(원본 msgInfo)가 pop 시점에 app별로 변환된 결과입니다.
                    BD=notification 블록 / JB=data-only(+ver). 토큰은 미리보기용 placeholder이며 데몬이 ver 등 일부를 추가할 수 있습니다.
                </p>
                <pre class="p-2 ql-pre ql-pre--sent">${escapeHtml(sentJson)}</pre>`;
        }

        const html = `
            <table class="table table-sm ql-det-table">
                <tbody>
                    <tr><th width="120">#</th><td>${r.num}</td></tr>
                    <tr><th>채널</th><td>${channelTag(r.channel)}</td></tr>
                    <tr><th>rel_table</th><td>${r.rel_table || '-'}</td></tr>
                    <tr><th>rel_action</th><td>${r.rel_action || '-'}</td></tr>
                    <tr><th>rel_id</th><td>${r.rel_id || '-'}</td></tr>
                    <tr><th>상태</th><td>${statusBadge(r)}</td></tr>
                    <tr><th>예약 (reg_time)</th><td>${r.reg_time || '-'}</td></tr>
                    <tr><th>시작 (start_time)</th><td>${r.start_time || '<span class="text-muted">-</span>'}</td></tr>
                    <tr><th>완료 (end_time)</th><td>${r.end_time || '<span class="text-muted">-</span>'}</td></tr>
                </tbody>
            </table>
            <h6 class="mt-3">payload <small class="text-muted">— 큐 적재 원본(msgInfo)</small></h6>
            <pre class="bg-light p-2 ql-pre">${escapeHtml(payload)}</pre>
            ${sentHtml}
        `;
        $j.Ui.JBModal.html('queue-log-detail', html, `큐 로그 #${r.num} (${r.channel})`, {width: '780px'});
    }, 'json');
}

// 채널 이름 — 색은 sass 의 .ql-ch[data-ch] (queue 파랑 · firebase 주황 · alimtalk 초록 · bizgo 보라, 그 외 #333)
function channelTag(ch) {
    return `<span class="ql-ch" data-ch="${escapeHtml(ch)}">${ch}</span>`;
}

function statusBadge(r) {
    if (r.end_time)   return '<span class="badge-status badge-done">완료</span>';
    if (r.start_time) return '<span class="badge-status badge-processing">처리중</span>';
    return '<span class="badge-status badge-pending">대기</span>';
}

function renderDt(v) {
    const [d, t] = String(v).split(' ');
    return `<span class="ql-dt">${d || ''} <span class="ql-blue">${t || ''}</span></span>`;
}

function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
}
